module.exports = __webpack_public_path__ + "static/nixon-agonistes-82440f5db29078fb44bcf3be61f35b6a.jpg";